import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/echelon_type`;

export const ACTION_TYPES = {
  FETCH_ECHELON_LIST: 'echelon/FETCH_ECHELON_LIST',
  RESET: 'echelon/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
};

// REDUCER
const echelonReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_ECHELON_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_ECHELON_LIST):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_ECHELON_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default echelonReducer;

// ACTIONS
export const getEntities = () => ({
  type: ACTION_TYPES.FETCH_ECHELON_LIST,
  payload: axios.get(apiUrl),
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
